import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAuthState, ILoginPayload, ILoginResponseOk, IRegistrationPayload, IRegistrationResponseOk } from '../../types/@auth';
import { IInterceptorError } from '../../types/@interceptor';
import { getAuthErrorMessage } from '../../helpers/auth-error';

const initialState: IAuthState = {
  id: '',
  permission: 0,
  token: '',
  organisationRoleSummary: {
    adminOrganisationIds: [],
    helperOrganisationIds: [],
    memberOrganisationIds: [],
    canSeeOrganisations: false,
    canManageEvents: false,
  },
  isLoading: false,
  errorMessage: '',
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state: IAuthState, _action: PayloadAction<ILoginPayload>) => {
      state.isLoading = true;
      state.errorMessage = '';
    },
    'login/ok': (_state: IAuthState, { payload }: PayloadAction<ILoginResponseOk>): IAuthState => {
      return {
        ...initialState,
        ...payload,
        isLoading: false,
        errorMessage: '',
        organisationRoleSummary: payload.organisationRoleSummary || initialState.organisationRoleSummary,
      };
    },
    'login/err': (state: IAuthState, { payload }: PayloadAction<IInterceptorError>) => {
      state.isLoading = false;
      state.errorMessage = getAuthErrorMessage(payload);
    },
    logout: (state: IAuthState) => initialState,
    registration: (state: IAuthState, _action: PayloadAction<IRegistrationPayload>) => {
      state.isLoading = true;
      state.errorMessage = '';
    },
    'registration/ok': (_state: IAuthState, { payload }: PayloadAction<IRegistrationResponseOk>): IAuthState => {
      return {
        ...initialState,
        ...payload,
        isLoading: false,
        errorMessage: '',
        organisationRoleSummary: payload.organisationRoleSummary || initialState.organisationRoleSummary,
      };
    },
    'registration/err': (state: IAuthState, { payload }: PayloadAction<IInterceptorError>) => {
      state.isLoading = false;
      state.errorMessage = getAuthErrorMessage(payload);
    },
    clearAuthFeedback: (state: IAuthState) => {
      state.errorMessage = '';
      state.isLoading = false;
    },
  },
});

export const authActions = authSlice.actions;
export const authReducer = authSlice.reducer;